import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { Button } from '@zep/ui';
import { SpaceWithPlanDto } from '../../../../../../types/SubscriptionType';
import { PlanSpaceCard } from '../PlanSpaceCard';
import S from './PlanCardsList.module.scss';
export const PlanCardsList = (props: SubscribedCardsWrapperProps) => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    spaceList
  } = props;
  const router = useRouter();
  if (!spaceList) return null;
  if (!spaceList.length) return <div className="mt-[24px] flex flex-col items-center">
        <img src="/images/empty_bolt_box.png" width={335} height={200} />
        <span className="text-subtitle font-semibold text-gray-900">
          {t('subscription:SpaceList.empty.title', '플랜이 적용된 스페이스가 없습니다')}
        </span>
        <span className="mb-[20px] mt-[6px] text-center text-body-1 font-medium text-gray-600">
          {t('subscription:SpaceList.empty.description', '플랜 업그레이드로 더 많은 인원을 수용하고 다양한 기능을 이용해 보세요.')}
        </span>
        <Button onClick={() => {
      router.push('/pricing');
    }}>
          {t('subscription:SpaceList.empyty.buttonToPricing')}
        </Button>
      </div>;
  return <div className={S.wrapper} data-sentry-component="PlanCardsList" data-sentry-source-file="PlanCardsList.tsx">
      {spaceList.map(space => <PlanSpaceCard key={space.spaceHashId} space={space} />)}
    </div>;
};
type SubscribedCardsWrapperProps = {
  spaceList: SpaceWithPlanDto[];
};